module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_1.3555c910.jpg";